$(document).on('click', '[data-luk-filter-modal]', function (event) {
	event.preventDefault();

	const $trigger = $(this);
	const $modal = $('#modal-luk-filter');
	const $content = $modal.find('[data-luk-filter-content]');

	$modal.modal('show');

	if ($modal.data('loaded') || $modal.data('loading')) {
		return;
	}

	$modal.data('loading', true);
	$.get($trigger.data('form-url'))
		.done(function (html) {
			$content.html(html);
			$modal.data('loaded', true);
		})
		.fail(function () {
			// The catalog page remains a usable fallback if the modal request fails.
			window.location.assign($trigger.attr('href'));
		})
		.always(function () {
			$modal.data('loading', false);
		});
});
